import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function dropdown(): ComponentStyle {
  return {
    componentName: 'dropdown',
    baseStyle: {
      width: 'auto',
      minWidth: '155px'
    }
  };
}
